import { useContext } from "react";

import { css } from "@emotion/react";
import TableCell from "@mui/material/TableCell";

import { colors } from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import TableContext from "context/table/tableContext";
import { parseResource, tableColumnRightDropShadow, useOverflow } from "shared";

import { useTableFunctions } from "../../hooks";
import { TableColumnProps } from "./types";

const TableColumn = ({
    data,
    name,
    resource,
    isRestricted,
    columnIdentifier,
    isSticky,
    isTranslatable,
    customDateTimeFormat,
    scrollHorizontal
}: TableColumnProps) => {
    const { gray200, gray900, textDisabled } = colors;

    const { isNotSelectable, columns, rows } = useContext(TableContext);

    const { ref, isOverflowing } = useOverflow([columns, rows]);
    const { renderValue } = useTableFunctions();

    const paddingLeft = () => {
        if (isSticky) {
            return isNotSelectable ? "0" : "60px";
        }

        return "unset";
    };

    const parsedValue = parseResource(resource, data);

    const value = renderValue(
        name,
        resource,
        data,
        columnIdentifier,
        customDateTimeFormat,
        isTranslatable
    );

    const textColor = isRestricted && parsedValue ? textDisabled : gray900;
    const boxShadowBottom = `inset 0px -1px 0px ${gray200}`;

    return (
        <TooltipGeneral
            title={value}
            disableHoverListener={!isOverflowing}
            placement={TOOLTIP_PLACEMENT.Top}
        >
            <TableCell
                ref={ref}
                css={css([
                    {
                        color: textColor,
                        position: isSticky ? "sticky" : "unset",
                        left: paddingLeft(),
                        boxShadow: boxShadowBottom
                    },
                    isSticky && tableColumnRightDropShadow(scrollHorizontal)
                ])}
            >
                {value}
            </TableCell>
        </TooltipGeneral>
    );
};

export default TableColumn;
